export const TEACHER_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export function isApprovedTeacher(teacher) {
  if (!teacher) return false;
  return !teacher.status || teacher.status === TEACHER_STATUS.APPROVED;
}

export function getTeacherAuthRole(teacher) {
  if (!teacher) return null;
  if (isApprovedTeacher(teacher)) return "teacher";
  if (teacher.status === TEACHER_STATUS.REJECTED) return "rejected_teacher";
  return "pending_teacher";
}
